import { Question } from './Question';
import { VideoModel } from './VideoModel';

export class CustomApplicantElement {
  viewedEventSent: boolean;
  name: string;
  id: number;
  intro: string;
  introVideoId: number | undefined;
  questions: Array<Question>;
  sortOrder: number;
  version: number;
  videos: Array<VideoModel>;
  applicantElementId: number;
}
